// extracted by mini-css-extract-plugin
module.exports = {"square":"_18651","placeholder":"_15824"};